import { BrickFactoryComponent } from './BrickFactoryComponent';

export default BrickFactoryComponent;